<template>
  <div :class="{row: this.buttonsDef.length}" v-if="render">
    <div :class="{'col-sm-8': this.buttonsDef.length}">
      <div class="form-group"
           @keyup.enter="_clickEnter"
           :data-code="element.code"
      >
        <label :title="tooltip(element.label)">
          {{ t(element.label) }}
          <icons-render v-if="element.icons" :propIcons="element.icons"/>
        </label>
        <select
          v-if="!element.readonly"
          v-model="value"
          :name="element.name"
          @change="_changeValue"
          :readonly="element.readonly"
          ref="element"
          class="width-100">
          <option
            v-for="item in element.items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
        <input
          v-if="element.readonly"
          :readonly="element.readonly"
          v-model="stValue"
          class="form-control"
        >
      </div>
    </div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import TypeHelper               from '../../../model/helper/TypeHelper'
import IconsRender              from '../../templates/widgets/icons-render'
import FormActionButton         from '../../widgets/forms/form-action-button'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'drop-down',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null,
          items:    {
            required: true,
            type:     Array,
            default:  () => {
              return []
            }
          }
        }
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    }
  },

  data () {
    return {
      value:   this.element.items.length ? this.element.items[0].value : null,
      stValue: this.element.items.length ? this.element.items[0].label : null,

      buttonsDef: [],
      render:     true
    }
  },

  created () {
    if (this.element.value !== null || typeof this.element.value !== undefined) {
      for (const item of this.element.items) {
        if (item.value == this.element.value) {
          this.value   = item.value
          this.stValue = item.label
        }
      }
    }
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)

    this._changeValue()

    let element = $(this.$refs.element)

    element.selectpicker({ noneSelectedText: this.$translate.text('cfm_nothing_selected') })
    element.selectpicker('setStyle', 'btn-select')
  },

  methods: {

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      if (value === null) {
        // this.value = this.element.items.length ? this.element.items[0].value : null
        this.value   = null
        this.stValue = null
        $(this.$refs.element).selectpicker('val', this.value)
        this._changeValue()

        return
      }

      if (TypeHelper.isNumeric(value)) {
        value = parseInt(value)
      }

      for (let i = 0; i < this.element.items.length; i++) {
        let compareValue = this.element.items[i].value

        if (TypeHelper.isNumeric(this.element.items[i].value)) {
          compareValue = parseInt(this.element.items[i].value)
        }

        if (compareValue === value) {
          this.value   = this.element.items[i].value
          this.stValue = this.element.items[i].label
          $(this.$refs.element).selectpicker('val', this.value)
          break
        }
      }
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _changeValue (event) {
      this._getStValue()

      let value = this.value
      if (TypeHelper.isNumeric(value)) {
        value = parseInt(value)
      }

      this.$emit('changeValue', { element: this.element, value: value, stValue: this.stValue })

      if (event) {
        this.$emit('blur', { element: this.element, value: value, stValue: this.stValue })
      }
    },

    /**
     *
     * @private
     */
    _getStValue () {
      for (let i = 0; i < this.element.items.length; i++) {
        if (parseInt(this.element.items[i].value) === parseInt(this.value)) {
          this.stValue = this.element.items[i].label
        }
      }
    },

    /**
     *
     * @private
     */
    _clickEnter (event) {
      let element             = $(this.$refs.element),
          originalSelectIndex = event.path[1].dataset.originalIndex,
          holder              = event.path[4]

      if (!holder.childNodes[2][originalSelectIndex]) {
        return
      }

      const selectOptionValue = holder.childNodes[2][originalSelectIndex].value

      this.value = selectOptionValue

      this._changeValue(event)

      element.selectpicker('val', selectOptionValue)
      element.selectpicker('toggle')

      let form   = element.closest('.form-element'),
          parent = form.parent(),
          number = form.data('number'),
          focusable,
          next

      number++

      focusable = parent
        .find('[data-number="' + number + '"]')
        .find('input:not([disabled="disabled"]):not(.tt-hint),select:not([tabindex="-98"]),textarea,button')
        .filter(':visible')
      next      = focusable.eq(focusable.index(this) + 1)
      if (next.length) {
        next.focus()
      }
      else {
        form.submit()
      }
    },

    /**
     *
     * @private
     */
    _clear () {
      this.updateValue(null)

      this._changeValue()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }

}
</script>
